export const listToObject = (results, identifier) => {
  // Turns results into a object with the identifier as the key.
  return results.reduce((acc, cur) => ({ ...acc, [cur[identifier]]: cur }), {});
};

export const listObjectsToListIds = (results, identifer) => {
  // Takes a lists of objects and returns a list of the identifiers from each object.
  return results.map((r) => r[identifer]);
};
